/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';

export class CustomerRow extends React.Component {

  static propTypes = {
    customer: PropTypes.object,
    remove: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  onDeleteClick (e) {
    e.preventDefault();
    this.props.remove(this.props.customer);
  }

  render () {
    var route = 'customers/' + this.props.customer.id;

    return (
      <tr>
        <td className='col-customer'>{this.props.customer.name}</td>
        <td className='col-orgnr'>{this.props.customer.vatNr}</td>
        <td className='col-ref'>{this.props.customer.contact}</td>
        <td className='col-address'>
          <span>{this.props.customer.address.street}</span>
          <span>{this.props.customer.address.zip} {this.props.customer.address.city}</span>
        </td>
        <td className='col-edit'><Link to={route} className='pen-link' /></td>
        <td className='col-remove'><Link to='/' className='remove-link' onClick={this.onDeleteClick}/></td>
      </tr>
    );
  }
}

export default CustomerRow;



/** WEBPACK FOOTER **
 ** ./src/views/customers/customer-row.js
 **/